import React from 'react';
import PreventiveMaintenanceReport from '../Reports/PreventiveMaintenance/PreventiveMaintenanceReport';
import { getPreferredLanguage } from '../../utilities/languagePreference';
import { translateUiText } from '../../utilities/siteTranslations';

const PreventiveMaintenance = () => {
    const preferredLanguage = getPreferredLanguage();
    const t = (value) => translateUiText(value, preferredLanguage);
    return (
        <div className="p-4">
            <div className="mb-4">
                <h2>{t('Preventive Maintenance & Fumigation Schedule')}</h2>
                <p className="text-color-secondary">{t('Plan, schedule, and track all preventative maintenance and fumigation tasks.')}</p>
            </div>
            <PreventiveMaintenanceReport />
        </div>
    );
};

export default PreventiveMaintenance;

